import dayjs from 'dayjs';
import { isNil } from 'lodash-es';
import { DatePickerType } from '../../type';
import { ParamsOption } from '../../config';
import * as echarts from 'echarts';
import { getMax, keepTwoNull } from '../../utils';

export const icons = [
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYycHgiIGhlaWdodD0iMzdweCIgdmlld0JveD0iMCAwIDYyIDM3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NC4xICg0MTQ1NSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiM4QkQ0RUEiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iMjYiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS41MDAwMDAsIDMxLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMjkuNTAwMDAwLCAtMzEuMDAwMDAwKSAiIHBvaW50cz0iMjkuNSAyNSA0MCAzNyAxOSAzNyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYycHgiIGhlaWdodD0iMzdweCIgdmlld0JveD0iMCAwIDYyIDM3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NC4xICg0MTQ1NSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiNCNkU3N0YiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iMjYiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS41MDAwMDAsIDMxLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMjkuNTAwMDAwLCAtMzEuMDAwMDAwKSAiIHBvaW50cz0iMjkuNSAyNSA0MCAzNyAxOSAzNyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYycHgiIGhlaWdodD0iMzdweCIgdmlld0JveD0iMCAwIDYyIDM3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NC4xICg0MTQ1NSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiNGRjk4NkEiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iMjYiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS41MDAwMDAsIDMxLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMjkuNTAwMDAwLCAtMzEuMDAwMDAwKSAiIHBvaW50cz0iMjkuNSAyNSA0MCAzNyAxOSAzNyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYycHgiIGhlaWdodD0iMzdweCIgdmlld0JveD0iMCAwIDYyIDM3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NC4xICg0MTQ1NSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiNGRjZEMkMiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iMjYiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS41MDAwMDAsIDMxLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMjkuNTAwMDAwLCAtMzEuMDAwMDAwKSAiIHBvaW50cz0iMjkuNSAyNSA0MCAzNyAxOSAzNyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYycHgiIGhlaWdodD0iMzdweCIgdmlld0JveD0iMCAwIDYyIDM3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NC4xICg0MTQ1NSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiM0QTkwRTIiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iMjYiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS41MDAwMDAsIDMxLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMjkuNTAwMDAwLCAtMzEuMDAwMDAwKSAiIHBvaW50cz0iMjkuNSAyNSA0MCAzNyAxOSAzNyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
];

interface LegendProps {
  show: boolean;
  name?: string;
  baselineValue?: number;
  colors?: string[];
  isRect?: boolean;
}

export type FormatterItem = {
  name: string;
  value: number;
  marker: string;
  data: [string, number | null];
  seriesName: string;
  dataIndex: number;
  axisValue: string;
  seriesIndex: number;
};

// 通用化配置项
export const getNormalChartOption = (
  selectBtn?: DatePickerType,
  unit?: string,
  baselineValue?: number,
  max?: number,
  isBoxTip = false
) => {
  // const colors = ['#1890ff', '#4fc7ec'];
  return {
    grid: {
      top: 95,
      bottom: 80,
    },
    dataZoom: {
      type: 'slider',
      bottom: 15,
      height: 20,
    },
    tooltip:
      isBoxTip && selectBtn === DatePickerType.DAY
        ? {
            trigger: 'axis',
            formatter: null,
          }
        : getTooltip({
            unit,
            mode: selectBtn,
            baselineValue,
          }),
    xAxis: getNormalAxis(selectBtn),
    yAxis: {
      type: 'value',
      name: unit,
      max: baselineValue ? (baselineValue > (max ?? 0) ? Math.ceil(baselineValue) : undefined) : undefined,
      nameTextStyle: {
        padding: -10,
        align: 'right',
      },
      nameGap: 30,
    },
  };
};

// tooltip 通用配置
export const getTooltip = ({
  unit = '',
  mode,
  baselineValue,
}: {
  unit?: string;
  mode?: DatePickerType;
  baselineValue?: number;
}) => ({
  formatter(items: FormatterItem[]) {
    const { axisValue } = items[0];
    // 根据选择的颗粒度，展示不同的tooltip
    let str: string;
    switch (mode) {
      case DatePickerType.MINUTE_1:
      case DatePickerType.MINUTE_15:
      case DatePickerType.HOUR:
        str = dayjs(axisValue, 'x').format('MM-DD[\n]HH:mm');
        break;
      case DatePickerType.DAY:
        str = dayjs(axisValue, 'x').format('MM-DD');
        break;
      default:
        str = dayjs(axisValue, 'x').format('YYYY-MM');
    }
    items.forEach(item => {
      const { seriesName, data } = item;
      const value = !isNil(data[1]) ? `${data[1].toFixed(2)}${unit}` : '--';
      str += `<br> ${seriesName}: ${value}`;
    });
    str += `<br> 基准值: ${keepTwoNull(baselineValue)}${unit}`;
    return str;
  },
});

// 图例通用配置
export const getLegend = ({ show, name, baselineValue, isRect = true }: LegendProps) => {
  let data;
  if (!isNil(baselineValue)) {
    data = [
      {
        name: name,
        icon: isRect ? 'rect' : 'path://M0 426.666667h1024v170.666666H0z',
      },
      {
        name: '基准',
        icon: 'path://M0 426.666667h1024v170.666666H0z',
      },
    ];
  } else {
    data = [
      {
        name: name,
        icon: isRect ? 'rect' : 'path://M0 426.666667h1024v170.666666H0z',
      },
    ];
  }
  return {
    show,
    right: 30,
    top: 50,
    data,
  };
};
const xAxis = {
  axisTick: {
    show: false,
  },
  splitLine: {
    show: false,
  },
};
export const rangeCatXAxis = (key: string) => {
  return {
    ...xAxis,
    type: 'time',
    minInterval: key === 'Hour' ? 60 * 1000 : key === 'Day' ? 60 * 1000 * 60 * 24 : 60 * 1000 * 60 * 24 * 28,
    axisLabel: {
      formatter: function (e: number) {
        if (key === 'Hour') {
          return dayjs(e, 'x').format('MM-DD[\n]HH:mm');
        } else if (key === 'Day') {
          return dayjs(e, 'x').format('MM-DD');
        } else {
          return dayjs(e, 'x').format('YYYY-MM');
        }
      },
    },
  };
};

/**
 *
 * @param type 颗粒度
 * @param maxIcon 图标1
 * @param minIcon 图标2
 * @returns
 * @decription 代替chartOptions文件中的markPoint
 */
export const getCommonMarkPint = (unit?: string, name?: string) => {
  return {
    label: {
      show: true,
      offset: [0, -4],
    },
    emphasis: {
      show: true,
      offset: [0, -4],
    },
    symbolSize: [name ? 160 : 120, 26],
    symbolOffset: [0, -13],
    data: [
      {
        type: 'max',
        name: '最高',
        symbol: `image://${icons[3]}`,
        itemStyle: {
          color: '#FF4D4F',
        },
        label: {
          formatter: function (data: any) {
            return `${name ?? ''}最高：${data.value.toFixed(2)}${unit}`;
          },
          color: '#FFFFFF',
        },
      },
      {
        type: 'min',
        name: '最低',
        symbol: `image://${icons[4]}`,
        itemStyle: {
          color: '#00ADFF',
        },
        label: {
          formatter: function (data: any) {
            return `${name ?? ''}最低：${data.value.toFixed(2)}${unit}`;
          },
          color: '#FFFFFF',
        },
      },
    ],
    itemStyle: {
      normal: {
        color: '#d6a223',
      },
    },
  };
};

export const getNormalAxis = (selectBtn?: DatePickerType) => {
  switch (selectBtn) {
    case DatePickerType.MINUTE_1:
    case DatePickerType.MINUTE_15:
    case DatePickerType.HOUR:
      return rangeCatXAxis('Hour');
    case DatePickerType.DAY:
      return rangeCatXAxis('Day');
    case DatePickerType.MONTH:
      return rangeCatXAxis('Month');
    default:
      return {};
  }
};

// 气电比
export const getPowerToElectricityRatioChart = ({ chartData, query, baselineConfigData }: ParamsOption) => {
  const unit = chartData?.list?.[0].physicalUnitName;
  const baselineValue = baselineConfigData?.find(i => i.granularityType === query?.granularityType)?.value;

  const max = getMax(chartData);
  const option = getNormalChartOption(query?.granularityType, unit, baselineValue, max);

  const colors = ['#1890ff', '#4fc7ec'];
  return {
    ...option,
    legend: getLegend({
      show: true,
      name: chartData?.list?.[0].name, // 气电比
      baselineValue,
      colors,
    }),
    series: [
      ...(chartData?.list ?? []).map(item => ({
        type: 'bar',
        color: colors,
        name: item.name,
        data: (item.chartValues ?? []).map(a => {
          return [a.ts, a.value];
        }),
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#81C3F3' },
            { offset: 1, color: '#4A90E2' },
          ]),
        },
      })),
      !isNil(baselineValue) && {
        //这两组数据用来模拟markLine线段开关,data可以为空
        name: '基准',
        type: 'line',
        color: '#FF477B',
        silent: true,
        markLine: {
          // silent: true,
          symbol: ['none', 'none'],
          lineStyle: {
            type: 'dashed',
            color: '#FF4D4F',
          },
          data: [
            {
              name: '基准',
              label: {
                formatter: `基准：${baselineValue}${unit}  `,
                color: '#FF477B',
                fontSize: 14,
                position: 'insideEndTop',
              },
              yAxis: baselineValue,
            },
          ],
        },
      },
    ],
  };
};

// 用电量
export const getTotalPowerConsumptionChart = ({ chartData, query, baselineConfigData }: ParamsOption) => {
  const unit = chartData?.list?.[0].physicalUnitName;
  const baselineValue = baselineConfigData?.find(i => i.granularityType === query?.granularityType)?.value;

  const max = getMax(chartData);
  const option = getNormalChartOption(query?.granularityType, unit, baselineValue, max);

  const colors = ['#1890ff', '#4fc7ec'];
  return {
    ...option,
    legend: getLegend({
      show: true,
      name: chartData?.list?.[0].name, // 用电量
      baselineValue,
      colors,
    }),
    series: [
      ...(chartData?.list ?? []).map(item => ({
        type: 'bar',
        color: colors,
        name: item.name,
        data: (item.chartValues ?? []).map(a => {
          return [a.ts, a.value];
        }),
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#81C3F3' },
            { offset: 1, color: '#4A90E2' },
          ]),
        },
      })),
      !isNil(baselineValue)
        ? {
            //这两组数据用来模拟markLine线段开关,data可以为空
            name: '基准',
            type: 'line',
            color: '#FF477B',
            silent: true,
            markLine: {
              // silent: true,
              symbol: ['none', 'none'],
              lineStyle: {
                type: 'dashed',
                color: '#FF4D4F',
              },
              data: [
                {
                  name: '基准',
                  label: {
                    formatter: `基准：${baselineValue}${unit}  `,
                    color: '#FF477B',
                    fontSize: 14,
                    position: 'insideEndTop',
                  },
                  yAxis: baselineValue,
                },
              ],
            },
          }
        : undefined,
    ],
  };
};

// 总流量
export const getTotalFlowChart = ({ chartData, query, baselineConfigData }: ParamsOption) => {
  const unit = chartData?.list?.[0].physicalUnitName;
  const baselineValue = baselineConfigData?.find(i => i.granularityType === query?.granularityType)?.value;

  const max = getMax(chartData);
  const option = getNormalChartOption(query?.granularityType, unit, baselineValue, max);

  const colors = ['#1890ff', '#4fc7ec'];
  return {
    ...option,
    legend: getLegend({
      show: true,
      name: chartData?.list?.[0].name, // 总流量
      baselineValue,
      colors,
    }),
    series: [
      ...(chartData?.list ?? []).map(item => ({
        type: 'bar',
        color: colors,
        name: item.name,
        data: (item.chartValues ?? []).map(a => {
          return [a.ts, a.value];
        }),
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#81C3F3' },
            { offset: 1, color: '#4A90E2' },
          ]),
        },
      })),
      !isNil(baselineValue)
        ? {
            //这两组数据用来模拟markLine线段开关,data可以为空
            name: '基准',
            type: 'line',
            color: '#FF477B',
            silent: true,
            markLine: {
              // silent: true,
              symbol: ['none', 'none'],
              lineStyle: {
                type: 'dashed',
                color: '#FF4D4F',
              },
              data: [
                {
                  name: '基准',
                  label: {
                    formatter: `基准：${baselineValue}${unit}  `,
                    color: '#FF477B',
                    fontSize: 14,
                    position: 'insideEndTop',
                  },
                  yAxis: baselineValue,
                },
              ],
            },
          }
        : undefined,
    ],
  };
};

// 瞬时功率
export const getInstantaneousPowerChart = ({ chartData, query, baselineConfigData }: ParamsOption) => {
  const unit = chartData?.list?.[0].physicalUnitName;
  const baselineValue = baselineConfigData?.find(i => i.granularityType === query?.granularityType)?.value;

  const max = getMax(chartData);
  const option = getNormalChartOption(query?.granularityType, unit, baselineValue, max, true);

  const colors = ['#00ADFF'];
  return {
    ...option,

    legend: getLegend({
      show: true,
      name: chartData?.list?.[0].name, // 瞬时功率
      baselineValue,
      colors,
      isRect: false,
    }),
    series: [
      ...(chartData?.list ?? []).map(item => {
        if (query?.granularityType === DatePickerType.DAY) {
          return {
            name: chartData?.list?.[0].name,
            type: 'custom',
            color: colors,
            dimensions: [
              '-',
              `最大${chartData?.list?.[0].name}`,
              `平均${chartData?.list?.[0].name}`,
              `最小${chartData?.list?.[0].name}`,
            ],
            itemStyle: {
              borderWidth: 1.5,
            },
            renderItem: function (params: any, api: any) {
              var xValue = api?.value(0);
              var highPoint = api?.coord([xValue, api.value(1)]);
              var avgPoint = api?.coord([xValue, api.value(2)]);
              var lowPoint = api?.coord([xValue, api.value(3)]);
              // var halfWidth = api?.size([0, 1])[1] / 2;
              // var offsetWidth =
              //   chartDataLength === 1 ? index : chartDataLength === 2 ? (2 * index - 1) * 8 : 16 * index - 16;
              // console.log(offsetWidth);
              var halfWidth = 8;
              var style = api?.style({
                stroke: api?.visual('color'),
                fill: undefined,
              });
              return {
                type: 'group',
                children: [
                  {
                    type: 'line',
                    transition: ['shape'],
                    shape: {
                      x1: highPoint[0] - halfWidth,
                      y1: highPoint[1],
                      x2: highPoint[0] + halfWidth,
                      y2: highPoint[1],
                    },
                    style: style,
                  },
                  {
                    type: 'line',
                    transition: ['shape'],
                    shape: {
                      x1: highPoint[0],
                      y1: highPoint[1],
                      x2: lowPoint[0],
                      y2: lowPoint[1],
                    },
                    style: style,
                  },
                  {
                    type: 'line',
                    transition: ['shape'],
                    shape: {
                      x1: avgPoint[0] - halfWidth,
                      y1: avgPoint[1],
                      x2: avgPoint[0] + halfWidth,
                      y2: avgPoint[1],
                    },
                    style: style,
                  },
                  {
                    type: 'line',
                    transition: ['shape'],
                    shape: {
                      x1: lowPoint[0] - halfWidth,
                      y1: lowPoint[1],
                      x2: lowPoint[0] + halfWidth,
                      y2: lowPoint[1],
                    },
                    style: style,
                  },
                ],
              };
            },
            encode: {
              x: 0,
              y: [1, 2, 3],
              tooltip: [1, 2, 3],
            },
            data: (item?.chartValues ?? []).map((a, index) => {
              return [a.ts, a.valueMax?.toFixed(2), a.value?.toFixed(2), a.valueMin?.toFixed(2)];
            }),
          };
        } else {
          return {
            type: 'line',
            color: colors,
            name: item.name,
            data: (item.chartValues ?? []).map(a => {
              return [a.ts, a.value];
            }),
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#89CFFF20' },
                { offset: 1, color: '#51A1FF10' },
              ]),
            },
            markPoint: getCommonMarkPint(unit),
          };
        }
      }),
      !isNil(baselineValue)
        ? {
            //这两组数据用来模拟markLine线段开关,data可以为空
            name: '基准',
            type: 'line',
            color: '#FF477B',
            silent: true,
            markLine: {
              // silent: true,
              symbol: ['none', 'none'],
              lineStyle: {
                type: 'dashed',
                color: '#FF4D4F',
              },
              data: [
                {
                  name: '基准',
                  label: {
                    formatter: `基准：${baselineValue}${unit}  `,
                    color: '#FF477B',
                    fontSize: 14,
                    position: 'insideEndTop',
                  },
                  yAxis: baselineValue,
                },
              ],
            },
          }
        : undefined,
    ],
  };
};
// 瞬时流量
export const getInstantaneousFlowChart = ({ chartData, query, baselineConfigData }: ParamsOption) => {
  const unit = chartData?.list?.[0].physicalUnitName;
  const baselineValue = baselineConfigData?.find(i => i.granularityType === query?.granularityType)?.value;

  const max = getMax(chartData);
  const option = getNormalChartOption(query?.granularityType, unit, baselineValue, max, true);

  const colors = ['#00ADFF'];
  return {
    ...option,
    legend: getLegend({
      show: true,
      name: chartData?.list?.[0].name, // 瞬时流量
      baselineValue,
      colors,
      isRect: false,
    }),
    series: [
      ...(chartData?.list ?? []).map(item => {
        if (query?.granularityType === DatePickerType.DAY) {
          return {
            name: chartData?.list?.[0].name,
            type: 'custom',
            color: colors,
            dimensions: [
              '-',
              `最大${chartData?.list?.[0].name}`,
              `平均${chartData?.list?.[0].name}`,
              `最小${chartData?.list?.[0].name}`,
            ],
            itemStyle: {
              borderWidth: 1.5,
            },
            renderItem: function (params: any, api: any) {
              var xValue = api?.value(0);
              var highPoint = api?.coord([xValue, api.value(1)]);
              var avgPoint = api?.coord([xValue, api.value(2)]);
              var lowPoint = api?.coord([xValue, api.value(3)]);
              // var halfWidth = api?.size([0, 1])[1] / 2;
              // var offsetWidth =
              //   chartDataLength === 1 ? index : chartDataLength === 2 ? (2 * index - 1) * 8 : 16 * index - 16;
              // console.log(offsetWidth);
              var halfWidth = 8;
              var style = api?.style({
                stroke: api?.visual('color'),
                fill: undefined,
              });
              return {
                type: 'group',
                children: [
                  {
                    type: 'line',
                    transition: ['shape'],
                    shape: {
                      x1: highPoint[0] - halfWidth,
                      y1: highPoint[1],
                      x2: highPoint[0] + halfWidth,
                      y2: highPoint[1],
                    },
                    style: style,
                  },
                  {
                    type: 'line',
                    transition: ['shape'],
                    shape: {
                      x1: highPoint[0],
                      y1: highPoint[1],
                      x2: lowPoint[0],
                      y2: lowPoint[1],
                    },
                    style: style,
                  },
                  {
                    type: 'line',
                    transition: ['shape'],
                    shape: {
                      x1: avgPoint[0] - halfWidth,
                      y1: avgPoint[1],
                      x2: avgPoint[0] + halfWidth,
                      y2: avgPoint[1],
                    },
                    style: style,
                  },
                  {
                    type: 'line',
                    transition: ['shape'],
                    shape: {
                      x1: lowPoint[0] - halfWidth,
                      y1: lowPoint[1],
                      x2: lowPoint[0] + halfWidth,
                      y2: lowPoint[1],
                    },
                    style: style,
                  },
                ],
              };
            },
            encode: {
              x: 0,
              y: [1, 2, 3],
              tooltip: [1, 2, 3],
            },
            data: (item?.chartValues ?? []).map((a, index) => {
              return [a.ts, a.valueMax?.toFixed(2), a.value?.toFixed(2), a.valueMin?.toFixed(2)];
            }),
          };
        } else {
          return {
            type: 'line',
            color: colors,
            name: item.name,
            data: (item.chartValues ?? []).map(a => {
              return [a.ts, a.value];
            }),
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#89CFFF20' },
                { offset: 1, color: '#51A1FF10' },
              ]),
            },
            markPoint: getCommonMarkPint(unit),
          };
        }
      }),
      !isNil(baselineValue)
        ? {
            //这两组数据用来模拟markLine线段开关,data可以为空
            name: '基准',
            type: 'line',
            color: '#FF477B',
            silent: true,
            markLine: {
              // silent: true,
              symbol: ['none', 'none'],
              lineStyle: {
                type: 'dashed',
                color: '#FF4D4F',
              },
              data: [
                {
                  name: '基准',
                  label: {
                    formatter: `基准：${baselineValue}${unit}  `,
                    color: '#FF477B',
                    fontSize: 14,
                    position: 'insideEndTop',
                  },
                  yAxis: baselineValue,
                },
              ],
            },
          }
        : undefined,
    ],
  };
};
